




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { FaqType } from '@/modules/faq/models/faq-resource.model'

@Component
export default class FaqTypeView extends Vue {
  @Prop({ required: true }) type: FaqType
  @Prop({ required: true }) types!: { [key in FaqType]: string }
  @Prop({ default: false }) dark: boolean

  get typeColor() {
    switch (this.type) {
      case FaqType.PANEL:
        return 'text-green'
      case FaqType.WRITER:
        return 'text-orange'
      default:
        return ''
    }
  }
}
